import { annotatorClient } from './annotatorClient';
import type { ExportResult } from '../types/annotator';

export async function exportProject(
  projectId: number,
  includeUnannotated = true,
  overwrite = false,
): Promise<ExportResult> {
  return annotatorClient.post<ExportResult>(`/projects/${projectId}/export/`, {
    include_unannotated: includeUnannotated,
    overwrite,
  });
}
